export const BUCKET_OPTION_TYPES = {
  filtered: 'FILTERED',
  nested: 'NESTED',
};
